/* unplugin-vue-components disabled */import { render } from "./SvgIconBookWithPen.vue?vue&type=template&id=7c6e5b9a"
import script from "./SvgIconBookWithPen.vue?vue&type=script&lang=js"
export * from "./SvgIconBookWithPen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__